import { api } from 'api';
import Swal from 'sweetalert2';
import { handleActions } from 'redux-actions';

export const DATA = "DASHBOARD_DATA";
export const LOADER = "DASHBOARD_LOADER";
export const NAVBAR_COLLAPSE = "NAVBAR_COLLAPSE";
export const MOSTRAR_DASHBOARD = "MOSTRAR_DASHBOARD";

const endpoint = "dashboard";


export const setDataDashboard = () => (dispatch, getStore) => {
    dispatch(setLoader(true));

    api
        .get(endpoint, {})
        .then(response => {
            if (response)
                dispatch(setData(response))
        })
        .catch(error => {
            // COMENTADO PORQUE NO ES UTIL AL USUARIO
            // Swal(
            //     'ERROR',
            //     'Ha ocurrido un error. Por favor intenta más tarde.',
            //     'error'
            // );
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
}

export const toggleNav = () => (dispatch, getStore) => {
    const navbarCollapse = getStore().dashboard.navbarCollapse;
    dispatch(setNavbarCollapse(!navbarCollapse));
};

const setDataActivarDashboard = (mostrar_dashboard) => (dispatch, getStore) => {
   
    dispatch({type: MOSTRAR_DASHBOARD, mostrar_dashboard});
   
    if(mostrar_dashboard){
      dispatch(setDataDashboard())
    }

  };


export const setNavbarCollapse = navbarCollapse => ({
    type: NAVBAR_COLLAPSE,
    navbarCollapse,
});

export const setData = data => ({
    type: DATA,
    data,
});
export const setLoader = loader => ({
    type: LOADER,
    loader,
});

const initFormbricks = (usuario) => {

    return (dispatch) => {
      const initializeFormbricksNow = () => {
        if (window.formbricks && typeof window.formbricks.init === "function") {
          if (window.formbricksInitialized) return;
          window.formbricksInitialized = true;
          // Preparar los datos del usuario
          const userId = usuario && usuario.id ? usuario.id.toString() : `user_${Date.now()}`;
          const userName = usuario && usuario.first_name ? `${usuario.first_name + ' ' +usuario.last_name}`  : "---";
          const userEmail = usuario && usuario.email ? usuario.email :`No tiene`;
          const userEmpresa = usuario && usuario.subdominio ? usuario.subdominio :`---`;

          // Inicializar Formbricks con los datos del usuario
          window.formbricks.init({
            //TEST
           // environmentId: "cm9d0cyj9002n124q3upw9g40",
           //PRODUCCION
            environmentId: "cm9d0cyjj002r124q44f12g1e",
            apiHost: "https://surveys.ciancoders.com",
            userId: userId,
            attributes: {
              name: userName,
              email: userEmail,
              empresa:userEmpresa,
            }
          }).then(() => {
            // Verificar si hay encuestas disponibles
            if (window.formbricks.checkForSurveys) {
                window.formbricks.checkForSurveys();
            }
          }).catch((error) => {
            console.error("Error al iniciar Formbricks:");
          });
        } else {
          console.warn("Formbricks no está disponible");
          loadFormbricksScript();
        }
      };
  
      const loadFormbricksScript = () => {
        // Eliminar cualquier script existente para evitar conflictos
        const existingScripts = document.querySelectorAll('script[src*="formbricks"], script[src*="surveys.ciancoders.com"]');
        existingScripts.forEach(script => {
          script.parentNode.removeChild(script);
        });
  
        // Cargar el script de Formbricks
        const script = document.createElement('script');
        script.src = 'https://surveys.ciancoders.com/api/packages/app';
        script.async = true;
  
        script.onload = () => {
          setTimeout(initializeFormbricksNow, 1000);
        };
  
        script.onerror = () => {
          // Intentar con una URL alternativa
          const alternativeScript = document.createElement('script');
          alternativeScript.src = 'https://cdn.formbricks.com/formbricks.js';
          alternativeScript.async = true;
  
          alternativeScript.onload = () => {
            setTimeout(initializeFormbricksNow, 1000);
          };
  
          alternativeScript.onerror = (error) => {
            console.error("Error al cargar el script alternativo de Formbricks:");
          };
  
          document.head.appendChild(alternativeScript);
        };
  
        document.head.appendChild(script);
      };
  
      if (window.formbricks) {
        initializeFormbricksNow();
      } else {
        loadFormbricksScript();
      }
    };
  };

export const actions = {
   setDataDashboard,
   setDataActivarDashboard,
   initFormbricks
};

// ------------------------------------
// Reducers
// ------------------------------------
export const reducers = {
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [NAVBAR_COLLAPSE]: (state, { navbarCollapse }) => {
        return {
            ...state,
            navbarCollapse,
        };
    },
    [MOSTRAR_DASHBOARD]: (state, { mostrar_dashboard }) => {
        return {
            ...state,
            mostrar_dashboard,
        };
    },
};

// ------------------------------------
// InitialState
// ------------------------------------

export const initialState = {
    data: {
        ventas: {
            hoy: 0,
            mes: 0,
            semana: 0,
        },
        compras: {
            hoy: 0,
            mes: 0,
            semana: 0,
        }
    },
    navbarCollapse: false,
    loader: false,
    mostrar_dashboard:false
};

export default handleActions(reducers, initialState);
